// extracted by mini-css-extract-plugin
export var avatarContainer = "_43-1";
export var largeAvatarContainer = "_43-2";
export var smallAvatarContainer = "_43-0";